import { Box, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import {
  filterListItemBtn,
  filterListItemIcon,
  filterListLabel,
  filterListLabelText,
} from './style';

export const FilterItem = ({ item }: { item: any }) => {
  const labelId = `checkbox-list-label-${item.id}`;
  const { control } = useFormContext();

  return (
    <ListItem key={item.id} disablePadding>
      <ListItemButton sx={filterListItemBtn} role={undefined} dense>
        <ListItemIcon sx={filterListItemIcon} data-testid={`filter-list-item-${item.id}`}>
          <Controller
            control={control}
            name={item.id}
            key={item.id}
            defaultValue={false}
            render={({ field: { onChange, value, ref } }) => (
              <Checkbox
                edge="start"
                disableRipple
                onChange={onChange}
                ref={ref}
                checked={value}
                data-testid={`map-filter-checkbox-${item.id}`}
              />
            )}
          />
        </ListItemIcon>
        <ListItemText
          id={labelId}
          primary={
            <Box sx={filterListLabel}>
              <item.icon height={22} width={22} fill="#049ACC" />
              <Box display="span" sx={filterListLabelText}>
                {item.label}
              </Box>
            </Box>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};
